/**
 * Definición del módulo que contendrá el menú de navegación superior.
 */
angular.module('NavMenu', ['Config', 'Loading', 'ui.router', 'pascalprecht.translate', 'CollapsableMenu']);